import * as React from "react"

import { cn } from '../../cn'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input
        data-component="Input"
        data-package="@appic/ui-components"
        data-testid="input"
        type={type}
        className={cn(
          "flex h-9 sm:h-10 w-full rounded-md border border-input-border bg-input px-3 sm:px-4 py-1 sm:py-2 text-base text-foreground shadow-sm transition-colors",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground",
          "hover:border-accent/40",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "min-w-0 max-w-full overflow-hidden",
          "md:text-sm min-h-touch sm:min-h-0",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
export type InputProps = React.ComponentProps<'input'>
